<div class="tf-admin main-content no-sidebar">
  <main class="workspace" id="main-content">
    <div class="workspace-header">
      <h1>Administración de Certifirma Digital Físico</h1>
      <p>Gestiona tu Certifirma Digital Físico (dispositivo USB) y el complemento de firma</p>
    </div>

    <!-- Cargando o complemento no detectado (mismo panel que Firmar) -->
    <div *ngIf="showNotAvailableView" class="step-container lap-step-host">
      <app-local-agent-unavailable-panel
        [loading]="statusLoading"
        loadingMessage="Comprobando tokens conectados…"
        featureTag="Administración de Certifirma Digital Físico"
        [downloadUrl]="agentDownloadUrl"
        title="Complemento de firma no detectado"
        message="Para administrar el Certifirma Digital Físico es necesario tener en ejecución el complemento local en tu equipo."
        (obtain)="openAgentDownload()"
        (refresh)="retryStatus()">
      </app-local-agent-unavailable-panel>
    </div>

    <!-- Sin tokens conectados -->
    <div *ngIf="noTokensConnected" class="step-container token-fisico-not-available tf-no-tokens" role="status" aria-live="polite">
      <div class="token-fisico-not-available-inner">
        <div class="token-fisico-not-available-icon tf-icon-info" aria-hidden="true">
          <i class="fas fa-usb-drive"></i>
        </div>
        <h2 class="token-fisico-not-available-title">No hay token conectado</h2>
        <p class="token-fisico-not-available-message">
          {{ tokenStatus?.message || 'Conecte un Certifirma Digital Físico (dispositivo USB) y pulse Actualizar para detectarlo.' }}
        </p>
        <div class="token-fisico-not-available-actions">
          <button type="button" class="btn btn-primary" (click)="retryStatus()" aria-label="Volver a comprobar tokens conectados">
            <i class="fas fa-rotate" aria-hidden="true"></i>
            Actualizar
          </button>
        </div>
      </div>
    </div>

    <!-- Tarjetas por token: mismo estilo que "Tipo de archivo" + pills como "Firma visible" -->
    <div *ngIf="showTokenCards" class="tf-admin-tokens">
      <div class="tf-admin-tokens-header">
        <p class="tf-admin-subtitle" *ngIf="tokenStatus?.multipleTokensPresent">
          Se detectaron varios tokens. Elija sobre cuál desea realizar la acción.
        </p>
        <button
          type="button"
          class="btn btn-secondary tf-refresh-btn"
          (click)="retryStatus()"
          [disabled]="statusLoading"
          aria-label="Actualizar lista de tokens conectados">
          <i class="fas fa-rotate" aria-hidden="true"></i>
          Actualizar
        </button>
      </div>
      <div class="tf-token-cards">
        <div *ngFor="let token of tokens" class="tf-token-card" [attr.aria-label]="'Token ' + token.label + ', slot ' + token.slotId">
          <div class="tf-token-card-row">
            <div class="tf-token-icon" aria-hidden="true">
              <i class="fas fa-microchip"></i>
            </div>
            <div class="tf-token-content">
              <div class="tf-token-label">{{ token.label }} · Slot {{ token.slotId }}</div>
              <div class="tf-token-desc">{{ token.manufacturer }} · {{ token.model }}</div>
              <div class="tf-token-meta">
                <span class="tf-token-serial">Serie {{ token.serialNumber }}</span>
                <span class="tf-badge" [class.locked]="token.isUserPinLocked" [attr.aria-label]="token.isUserPinLocked ? 'PIN bloqueado' : 'PIN OK'">
                  {{ token.isUserPinLocked ? 'PIN bloqueado' : 'PIN OK' }}
                </span>
                <span class="tf-badge so-pin" [class.locked]="token.isSoPinLocked" [attr.aria-label]="token.isSoPinLocked ? 'SO-PIN bloqueado' : 'SO-PIN OK'">
                  SO-PIN {{ token.isSoPinLocked ? 'bloqueado' : 'OK' }}
                </span>
              </div>
            </div>
          </div>
          <div class="tf-token-actions">
            <button type="button" class="tf-action-pill tf-action-validar" (click)="openConsultarContenido(token)" [attr.aria-label]="'Consultar contenido del token ' + token.label">
              <span class="tf-action-icon"><i class="fas fa-check-circle" aria-hidden="true"></i></span>
              <span>Consultar contenido</span>
            </button>
            <button type="button" class="tf-action-pill tf-action-restablecer" (click)="openRestablecerPin()" [attr.aria-label]="'Restablecer PIN (solo si hay un único token conectado)'">
              <span class="tf-action-icon"><i class="fas fa-key" aria-hidden="true"></i></span>
              <span>Restablecer PIN</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
